import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ASecureForm} from '../../../../sdk/interface/form/ASecureForm';
import {Account, SettlementBatch, WebAccountService, WebSettlementService} from 'web-angular-client';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder} from '@angular/forms';
import {AuthenticationService} from '../../../../sdk/service/authentication.service';
import {AlertService} from '../../../../sdk/service/alert.service';
import {AccountStatusUtil} from '../../../../sdk/interface/accountStatusUtil';
import {ROUTES} from '../../../../app.routes';
import {EnvironmentService} from '../../../../sdk/service/environment.service';
import {Location} from '@angular/common';

@Component({
    selector: 'app-batch-view',
    templateUrl: './batch-view.component.html',
    styleUrls: ['./batch-view.component.scss'],
    standalone: false
})
export class BatchViewComponent extends ASecureForm implements OnInit, OnDestroy
{
    settlementBatch: SettlementBatch;
    accounts: Account [];
    interval: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        private alertService: AlertService,
        private webSettlementService: WebSettlementService,
        private webAccountService: WebAccountService,
        protected accountStatusUtil: AccountStatusUtil,
        private location: Location,
        private changeDetectorRef: ChangeDetectorRef)
    {
        super(authenticationService, environmentService);
    }

    ngOnInit()
    {
        this.route.params.subscribe(params =>
        {
            const batchId = params['id'];

            this.loadBatch(batchId);
            this.loadBatchAccounts(batchId);
        });

        this.interval = setInterval(() =>
        {
            this.loadBatch(this.settlementBatch.id);
            this.loadBatchAccounts(this.settlementBatch.id);
        }, 5000);
    }

    ngOnDestroy(): void
    {
        clearInterval(this.interval);
    }

    back()
    {
        this.location.back();
    }

    public getAccountStatusUtil(): AccountStatusUtil
    {
        return this.accountStatusUtil;
    }

    public view(account: Account)
    {
        if (this.isGuestAdminUser())
        {
            this.displayGuestPrivilegeError();
            return;
        }
        this.router.navigate([ROUTES.SECURE.ACCOUNT.VIEW.pathSansParameters, account.id]).then();
    }

    private loadBatch(id: number)
    {
        this.debugOutput('Load Batch ID ' + id);
        this.webSettlementService.getSettlementBatchById(id).subscribe({
            next: batch =>
            {
                this.settlementBatch = batch;
            },
            error: error =>
            {
                this.alertService.error(error, true);
                this.router.navigate([this.routes.SECURE.SETTLEMENT_BATCH.LIST.path]).then();
            }
        });
    }

    private loadBatchAccounts(id: number)
    {
        this.webAccountService.getAccountsBySettlementBatchId(id).subscribe({
            next: accounts =>
            {
                this.accounts = accounts;
            },
            error: error =>
            {
                this.alertService.error(error, true);
                this.router.navigate([this.routes.SECURE.SETTLEMENT_BATCH.LIST.path]).then();
            }
        });
    }

    private displayGuestPrivilegeError(): void
    {
        this.alertService.error('Guest accounts cannot perform this action.', false);
    }
}